import { create } from 'zustand';

export const dialogActionStore = create((set) => ({
    dailogType: null,
    dialogActionData: null,
    conflictData: null,
    emptyDialogActionData: () => set({
        dailogType: null,
        dialogActionData: null,
        conflictData: null
    }),
    setDialogActionData: (data) => set((prev) => ({ ...prev, ...data })),
}));

export default dialogActionStore;